<template>
  <div class="gdt-modify-wrapper">
    <FixedHeader v-model="currTaskId" @change="onTaskChange" @remove="onTaskTabRemove" :before-change="beforeTaskChange">
      <FixedItem v-for="task in taskStates" :key="task.id" :data="task">
        <span>{{ task.id }}&ensp;</span>
        <em v-if="pageStates.isDuplicate" @click.stop="onTaskDuplicate(task)" class="el-icon-copy-document"></em>
      </FixedItem>
    </FixedHeader>

    <div class="plan-modify ghost-button-styles" v-loading="pageLoading">
      <Moduler name="a" title="基础信息">
        <BasicPlanInfo ref="gdt-v3-form-basic" :class="configBlockModifyForbid" v-model="planForm">
          <el-form-item label="账号选择" prop="accounts">
            <el-select style="width: 320px" v-model="planForm.accounts[0]" filterable clearable placeholder="请选择投放账号">
              <el-option v-for="item in accountList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
        </BasicPlanInfo>
      </Moduler>

      <Moduler name="a" title="营销目标及场景">
        <MaketingGoal v-model="planForm" ref="gdt-v3-form-marketing-goal" :class="adBlockModifyForbid"></MaketingGoal>
      </Moduler>

      <Moduler name="a" title="计划版位">
        <Siteset v-model="planForm" :class="adBlockModifyForbid"></Siteset>
      </Moduler>

      <Moduler name="a" title="定向" v-if="targetingForm">
        <Targeting
          v-model="targetingForm"
          :ad-marketing-scene="planForm.ad_marketing_scene"
          :class="adBlockModifyForbid"
          ref="gdt-v3-form-target"
        ></Targeting>
      </Moduler>

      <Moduler name="a" title="关键词" v-if="planForm.ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SEARCH">
        <el-form label-width="180px">
          <el-form-item label="关键词">
            <!-- :disabled="!targetingForm.account.id" -->
            <el-button @click="onSearchKeywordAdd">+添加关键词</el-button>
            <span>&emsp;已选{{ planForm.searchAdBidKeywords.length }}/1000</span>

            <!-- 关键词选择弹窗 -->
            <SearchBidKeywordSelectModal
              v-model="showSearchBidKeywordModal"
              :account-id="planForm.accounts[0]"
              :list="searchBidKeywordList"
              :media-type="2"
              :filter-types="[{ label: '以词拓词', value: 1 }]"
              :patern-list="SEARCH_AD_BID_KEYWORD_PATERN"
              @confirm="onSearchKeywordSelectConfirm"
            ></SearchBidKeywordSelectModal>
          </el-form-item>
        </el-form>
      </Moduler>

      <Moduler name="a" title="排期及预算" v-if="budgetForm">
        <BudgetBid v-model="budgetForm" ref="gdt-v3-form-bid" :plan-form="planForm" :class="adBlockModifyForbid">
          <template v-slot:daterange>
            <el-form-item label="投放时间">
              <el-date-picker
                v-model="budgetForm.rangeDate"
                :picker-options="{ disabledDate: (date) => date && date.valueOf() < Date.now() - 1000 * 60 * 60 * 24 }"
                type="daterange"
                range-separator="~"
                style="width: 292px"
                :clearable="false"
              >
              </el-date-picker>
            </el-form-item>
          </template>

          <template v-slot:materialTags>
            <el-form-item label="投放素材标签（选填）">
              <div class="material-tags">
                <el-select
                  v-model="budgetForm.material_package_id"
                  clearable
                  placeholder=""
                  :disabled="pageStates.isModify"
                  @change="onMaterialLabelChange"
                >
                  <el-option v-for="item in materialTagList" :key="item.tagId" :label="item.mediaTagName" :value="item.tagId"> </el-option>
                </el-select>

                <el-button type="text" @click="queryMaterialTags" :loading="materialTagsLoading">&ensp;刷新</el-button>
              </div>
            </el-form-item>
          </template>
        </BudgetBid>
      </Moduler>

      <!-- 是否相似计划提醒弹窗 -->
      <el-dialog :visible.sync="showPlanInvalidModal" :show-close="false" :close-on-click-modal="false" width="325px">
        <p style="text-align: center"><em class="el-icon-warning" style="color: orange; font-size: 24px"></em></p>
        <p>{{ planInvalidModalMsg }}</p>

        <div slot="footer" style="text-align: center">
          <el-button type="primary" @click="showPlanInvalidModal = false">我知道了</el-button>
        </div>
      </el-dialog>

      <!-- 组件化创意形式 -->
      <div v-if="creativeFormGroups">
        <!-- 只有批量复制时显示可复制 -->
        <CreativeGroupTags
          v-model="creativeGroupIndex"
          :groups="creativeFormGroups"
          v-if="pageStates.isDuplicate"
          @copy="onCreativeGroupDuplicate"
          @remove="onCreativeGroupItemRemove"
        >
        </CreativeGroupTags>

        <ComponentBasedCreative
          ref="gdt-v3-form-creative"
          :groups="creativeFormGroups"
          :group.sync="creativeFormGroups[creativeGroupIndex]"
          :creativeGroupIndex="creativeGroupIndex"
          :material-package-id="budgetForm.material_package_id"
          :material-tag-list="materialTagList"
        ></ComponentBasedCreative>
      </div>

      <div class="submit-row">
        <el-button type="primary" @click="onProjectSubmit" :loading="submitLoading">确认提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { getSession } from '@/common/js/api'
import { clone, groupBy } from '@/common/js/just.js'
import { FixedHeader, FixedItem } from '@/components/fixed-header/index.js'
import { dataFormatter } from '@/components/material-selector/utils.js'
import Moduler from '@/components/moduler'
import BasicPlanInfo from '../components/plan/basic.vue'
import MaketingGoal from './components/plan/maketing-goal.vue'
import Siteset from '../components/plan/siteset.vue'
import Targeting from '../components/target/index.vue'
import BudgetBid from '../components/budget/index.vue'
import ComponentBasedCreative from './components/creative/component-based-creative/index.vue'
import CreativeGroupTags from './components/creative/creative-group-tags.vue'
import SearchBidKeywordSelectModal from '@/views/create/bytedance/components/project/components/search-bid.vue'

import { findPlanTaskById } from '@/api/toutiao.local.model'
import {
  submitTencentV3Plans,
  updateTencentV3Plans,
  submitTencentSearchAdPlans,
  updateTencentSearchAdPlans
} from '@/api/tencentada.model.js'
import { adAccount, queryImageDetailByIds } from '@/api/common.model'
import { removeMaterialTags, addMaterialTags, checkAdRepeat } from '@/api/tencent.model'
import { getAllMediaTagList } from '@/api/material.model.js'
import { RULES } from '../model/project-rules.js'
import { SITE_ENUM } from '../model/siteset/siteset-const.js'
import { DEEP_CONVERSION_TYPE, BID_SCENE } from '../model/budget/budget-const.js'
import { getV3ModifyPlanForm, getPlanForm, getMaterialTagForm } from '../model/project-form.js'
import { makeV3InnerPlanParams, makeV3CreativeParams, makeV3OuterPlanParams, makeSearchAdParams } from '../model/distribute-form.js'
import { projectComputedMethods, projectMethods } from '../model/project-mixins.js'
import { creativeMethods } from '../model/creative-mixins.js'
import { MEDIAS } from '@/common/js/constants.js'
import taskCommonMethods from '@/views/edit/common/edit.js'
import { AD_MARKETING_SCENE, SEARCH_AD_BID_KEYWORD_PATERN } from '../model/project-const'

// 保存被复制次数
let taskDupIndex = 1

const taskIds = getSession('taskIds') || []

let regionList = []

fetch('/data/tencent_region.json')
  .then((res) => res.json())
  .then((data) => {
    regionList = data
  })

export default {
  components: {
    FixedHeader,
    FixedItem,
    Moduler,
    BasicPlanInfo,
    MaketingGoal,
    Siteset,
    Targeting,
    BudgetBid,
    ComponentBasedCreative,
    CreativeGroupTags,
    SearchBidKeywordSelectModal
  },
  provide() {
    return {
      projectInstance: this,
      creativeInstance: this
    }
  },
  data() {
    return {
      BID_SCENE,
      AD_MARKETING_SCENE,
      SEARCH_AD_BID_KEYWORD_PATERN,
      formPrefix: 'gdt-v3-form',
      pageLoading: false,
      dupActionLoading: false,
      templateDetailLoading: false,
      submitLoading: false,
      // showAddMaterialTagModal: false,
      materialTagsLoading: false,
      showPlanInvalidModal: false,
      planInvalidModalMsg: '',
      // firstMaterialLabelChange: true,

      creativeGroupIndex: 0,

      currTaskId: 0,
      accountList: [],
      taskList: [],
      materialTagList: [],

      materialTagRules: RULES.materialTagRules.call(this),
      // materialTagForm: getMaterialTagForm()

      showSearchBidKeywordModal: false,
      searchBidKeywordList: []
    }
  },
  computed: {
    /**
     * @description: pageStates, adAccounts
     * @return {*}
     */
    ...projectComputedMethods,

    currTask() {
      if (this.taskList.length) {
        const task = this.taskList.find((task) => task.taskId === this.currTaskId)
        return task
      }
      // 默认表单
      return {
        planForm: getPlanForm()
      }
    },
    taskIndex() {
      return this.taskList.findIndex((task) => task.taskId === this.currTaskId)
    },
    planForm: {
      get() {
        return this.currTask.planForm
      },
      set(form) {
        if (this.taskIndex > -1) {
          this.taskList.splice(this.taskIndex, 1, {
            ...this.taskList[this.taskIndex],
            planForm: form
          })
        }
      }
    },
    targetingForm: {
      get() {
        return this.currTask.targetingForm
      },
      set(form) {
        if (this.taskIndex > -1) {
          this.taskList.splice(this.taskIndex, 1, {
            ...this.taskList[this.taskIndex],
            targetingForm: form
          })
        }
      }
    },
    budgetForm: {
      get() {
        return this.currTask.budgetForm
      },
      set(form) {
        if (this.taskIndex > -1) {
          this.taskList.splice(this.taskIndex, 1, {
            ...this.taskList[this.taskIndex],
            budgetForm: form
          })
        }
      }
    },

    creativeFormGroups: {
      get() {
        return this.currTask.creativeFormGroups
      },
      set(groups) {
        if (this.taskIndex > -1) {
          this.taskList.splice(this.taskIndex, 1, {
            ...this.taskList[this.taskIndex],
            creativeFormGroups: groups
          })
        }
      }
    },
    currTaskCreativeAssets() {
      const selectedAssets = []
      this.taskList.forEach((task) => {
        // [...task.creativeFormGroups.map((creative) => creative.selectedAssets)]

        const creativeFormGroups = task.creativeFormGroups

        for (let i = 0; i < creativeFormGroups.length; i++) {
          const creative = creativeFormGroups[i]
          selectedAssets.push(...Object.values(creative.selectedAssets))
        }
      })

      return selectedAssets
    },

    taskStates() {
      return this.taskList.map((task) => task.taskStates)
    },
    hasMoment() {
      return this.planForm.siteSet.includes(SITE_ENUM.MOMENTS)
    },

    /**
     * @description: 批量修改时，不允许修改基础信息、广告应用与营销目标、版位
     */
    configBlockModifyForbid() {
      return this.pageStates.isModify ? 'disable-plan-form' : ''
    },

    /**
     * @description: 广告块禁止修改逻辑，如果广告新建成功，不允许修改广告
     */
    adBlockModifyForbid() {
      // ada task_progress > 3 广告新建成功
      const adSucc = this.currTask.task_progress > 3
      return adSucc && this.pageStates.isModify ? 'disable-plan-form' : ''
    }
  },
  methods: {
    /**
     * @description: 一些可以复用的任务组件函数
     * @description: onTaskTabRemove, onTaskTabChange, taskFormValidator, doCurrentFormValidate, doCannel
     */
    ...taskCommonMethods,

    /**
     * @description: 新建、批量等可以复用的创意组件函数
     * @description: getCreativeTemplates, getPromotedObjectList, getCreativeTemplateById
     * @description: onCreativeTemplateChange, onCreativeAssetChange
     */
    ...creativeMethods,

    /**
     * @description: 新建、批量等可以复用的项目组件函数
     * @description: onClearPormotedObject
     */
    ...projectMethods,

    onSearchKeywordAdd() {
      this.showSearchBidKeywordModal = true
      this.searchBidKeywordList = this.planForm.searchAdBidKeywords
    },

    onSearchKeywordSelectConfirm(words = []) {
      if (Array.isArray(words) && words?.length) {
        this.planForm.searchAdBidKeywords = words.slice(0, 1000)
      }
    },

    onTaskChange(id) {
      this.onTaskTabChange(id)
      this.creativeGroupIndex = 0
      this.$nextTick(() => {
        this.queryMaterialTags()
      })
    },

    beforeTaskChange() {
      for (let i = 0; i < this.taskList.length; i++) {
        const { creativeFormGroups } = this.taskList[i]
        const hasPlaceholderItem = creativeFormGroups.some((group) => {
          const { image_list } = group.selectedAssets || {}
          return image_list?.some((img) => img.placeholder === true)
        })

        if (hasPlaceholderItem) {
          this.$Message.warning('请等待组图生成缩略图')
          return Promise.reject(new Error('请等待组图生成缩略图'))
        }
      }

      return this.doCurrentFormValidate().catch((error) => {
        this.showBidAdjustmentTaskError(error)
        return Promise.reject(error)
      })
    },

    showBidAdjustmentTaskError(error) {
      const fields = ['bid_adjustment_site_set', 'bid_adjustment_shallow_coefficient', 'bid_adjustment_deep_coefficient']
      for (const field of fields) {
        const errors = error?.[field]
        const message = Array.isArray(errors) ? errors[0]?.message : errors?.message
        if (message) {
          this.$Message.error(`任务 ${this.currTaskId}：${message}`)
          return true
        }
      }
      return false
    },

    // onBidSceneChange(scene) {
    //   // 日预算切换到设置预算
    //   if (scene === BID_SCENE.NORMAL_MAX) {
    //     this.budgetForm = {
    //       ...this.budgetForm,
    //       budget: 1,
    //       bid_amount: ''
    //     }
    //   }
    // },

    /**
     * @description: 轮询获取组图占位项缩略图
     * @return {*}
     */
    initQueryGroupImageThumbnailLoop() {
      setInterval(async () => {
        const groups = this.creativeFormGroups
        for (let i = 0; i < groups.length; i++) {
          const group = groups[i]
          const { image_list } = group.selectedAssets || {}

          if (image_list?.length) {
            // 获取组图占位项id
            const ids = image_list.filter((img) => img.placeholder === true).map((img) => img.id)
            if (ids.length) {
              // 获取缩略图详情
              let imageLists = await queryImageDetailByIds({ imageDetailIds: ids })
              imageLists = imageLists.map((item) => item.items[0])
              for (let j = 0; j < imageLists.length; j++) {
                // 如果没有缩略图地址，跳过，等待下次轮询
                if (!imageLists[j]?.overview_addr) continue
                const image = dataFormatter.group_image(imageLists[j])
                const index = image_list.findIndex((img) => Number(img.id) === image.id)
                // 替换占位项内容
                if (index > -1) {
                  group.selectedAssets.image_list[index] = { ...image }
                }
              }
            }
          }
        }
        // 先进行一次清空，否则v-for不会渲染
        this.creativeFormGroups = this.creativeFormGroups.map((i) => ({ ...i, selectedAssets: {} }))

        this.$nextTick(() => {
          this.creativeFormGroups = groups
        })
      }, 5000)
    },

    /**
     * @description: 校验广告是否相似
     */
    async checkAd() {
      const checkRule = '识别规则：(版位+应用+定向性别+素材标签)账号唯一；'
      for (let i = 0; i < this.taskList.length; i++) {
        const task = this.taskList[i]
        const { accounts, promotedObject, siteSet } = task.planForm
        const { optimization_goal, deep_conversion_spec, deep_bid_mode, material_package_id } = task.budgetForm
        const { gender } = task.targetingForm
        // (批量修改情况下)如果任务广告新建完了，不验证相似性
        if (this.pageStates.isModify && task.task_progress > 3) {
          continue
        }
        const checkParams = {
          ad_account_id: accounts[0],
          material_package_id,
          site_set: siteSet,
          marketing_carrier_detail: {
            marketing_carrier_id: promotedObject.promoted_object_id
          },
          targeting: [{ gender: gender ? [gender] : undefined }],
          optimization_goal,
          deep_conversion_spec: {}
        }
        // 添加深度转化参数
        if (deep_bid_mode) {
          const { deep_conversion_type, deep_conversion_worth_spec, deep_conversion_behavior_spec } = deep_conversion_spec
          const deepGoalSpec = {}
          deepGoalSpec.deep_conversion_type = deep_conversion_type
          if (deep_conversion_type === DEEP_CONVERSION_TYPE.BEHAVIOR) {
            deepGoalSpec.goal = deep_conversion_behavior_spec.goal
          }
          if (deep_conversion_type === DEEP_CONVERSION_TYPE.WORTH) {
            deepGoalSpec.goal = deep_conversion_worth_spec.goal
          }
          checkParams.deep_conversion_spec = deepGoalSpec
        }
        // 返回值： true | {msg: 'blablabla'}
        const isValid = await checkAdRepeat(checkParams)
        if (!isValid || typeof isValid !== 'boolean') {
          this.showPlanInvalidModal = true
          this.planInvalidModalMsg = `(${task.taskId})${isValid};${checkRule}`
          return Promise.reject(new Error('checkAdRepeat check failed'))
        }
      }
    },

    /**
     * @description: 复制一条当前任务
     */
    async onTaskDuplicate(task) {
      let newTask = this.taskList.find((t) => t.taskId === task.id)
      this.dupActionLoading = true
      // 任务素材过多时，会有渲染卡顿，加个延时处理一下
      await this.$nextTick()
      newTask = clone(newTask)

      const taskId = `复制任务${taskDupIndex++}`

      newTask.taskId = taskId
      newTask.taskStates.id = taskId
      newTask.planForm.project_name += `_${taskId}`

      this.taskList.push(newTask)

      setTimeout(() => {
        this.dupActionLoading = false
      }, 500)
    },

    /**
     * @description: 复制当前的创意组
     */
    onCreativeGroupDuplicate(index) {
      const dupItem = { ...this.creativeFormGroups[index] }
      dupItem.groupName = `创意组${this.creativeFormGroups.length + 1}_复制`
      this.creativeFormGroups = [...this.creativeFormGroups, clone(dupItem)]
      this.creativeGroupIndex = this.creativeFormGroups.length - 1
    },
    onCreativeGroupItemRemove(index) {
      this.creativeGroupIndex = Math.max(0, index - 1)
      this.creativeFormGroups = this.creativeFormGroups.filter((_, _index) => _index !== index)
    },

    /**
     * @description: 批量提交修改后的项目
     */
    async onProjectSubmit() {
      const allFilled = this.taskStates.every((s) => s.filled)
      if (!allFilled) {
        return this.$Message.error('请切换任务编号，首次加载数据成功方可提交')
      }

      // 项目信息校验
      this.doCurrentFormValidate()
        .then(() => {
          const taskList = []

          // tg4.40支持任务内复制创意组，根据创意组打平成多个任务再进行提交参数构建
          for (let i = 0; i < this.taskList.length; i++) {
            const { creativeFormGroups, ...task } = this.taskList[i]

            for (let j = 0; j < creativeFormGroups.length; j++) {
              const creative = creativeFormGroups[j]
              taskList.push({ ...task, creative })
            }
          }
          this.submitLoading = true

          const planlist = taskList
            .map((task) => {
              // 修改下数据key，保持与新建流程一致，共用构建提交参数函数
              const { planForm, targetingForm, budgetForm, ...rest } = task
              return {
                ...rest,
                plan: planForm,
                target: targetingForm,
                bid: budgetForm
              }
            })
            .map((task) => {
              const { convert_name, taskId, task_progress, task_status, plan } = task
              const [account] = plan.accounts

              // 计划和创意是否开启；默认关闭
              const operation = task.plan.operation || 'disable'

              const params = {
                ad_account_id: account,
                convert_name,
                inner_plan_params: makeV3InnerPlanParams(task),
                creative_params: { ...makeV3CreativeParams(task), operation },
                outer_plan_params: { ...makeV3OuterPlanParams(task, regionList), operation },
                taskId,
                task_progress,
                task_status
              }

              // 搜索广告计划参数
              if (params.outer_plan_params.ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SEARCH) {
                // 由于新建时搜索广告关键词是在定向参数内，为了满足新建计划结构，这里需要将关键词放到target内
                task.target.searchAdBidKeywords = plan.searchAdBidKeywords
                return { ...makeSearchAdParams(task, params), taskId, task_progress, task_status }
              }

              return params
            })
          const [firstTask] = this.taskList
          const operation = this.pageStates.isDuplicate ? 'enable' : firstTask?.operation
          const params = { operation, planlist }
          const [firstRow] = planlist
          const isSearchAd = !!firstRow.campaign_params
          let submitRequest = () => {}
          if (isSearchAd) {
            submitRequest = this.pageStates.isDuplicate ? submitTencentSearchAdPlans : updateTencentSearchAdPlans
          } else {
            submitRequest = this.pageStates.isDuplicate ? submitTencentV3Plans : updateTencentV3Plans
          }

          submitRequest(params)
            .then((data) => {
              if (data) {
                this.$Message.success('提交成功，2秒后自动关闭页面')

                setTimeout(() => {
                  window.close()
                }, 2000)
              }
            })
            .finally(() => {
              this.submitLoading = false
            })
        })
        .catch((e) => {
          this.submitLoading = false
          // 创意组校验不通过时返回校验失败的创意组索引，e = number 且会大于-1
          if (typeof e === 'number' && e > -1) {
            // 切换到对应的创意组
            this.creativeGroupIndex = e
          }
          if (!this.showBidAdjustmentTaskError(e)) {
            e?.message && this.$Message.error(e.message)
          }
          console.log('doCurrentFormValidate error output: ', e)
        })
    },
    /**
     * @description: 获取任务数据，并构建对应的项目，定向，出价，创意参数
     */
    async getTaskData() {
      try {
        const { type } = this.$route.query
        this.pageLoading = true
        const data = await findPlanTaskById({ taskIds })
        const taskList = []

        for (let i = 0; i < data.length; i++) {
          const item = data[i]
          const task = await getV3ModifyPlanForm.call(this, item)
          taskList.push({
            ...task,
            taskStates: {
              id: item.taskId,
              filled: i === 0 // 默认第一个任务为选中
            }
          })
        }

        // 20240723天工v4.42，根据type标记判断是否需要合并创意组
        // megercreatives在src/components/converter/betch-copy.vue中通过url query传递
        if (type === 'megercreatives') {
          // 腾讯广告：根据广告名称分组
          const groups = groupBy(taskList, (i) => i.planForm.originProjectName)

          const taskObj = {}
          // 处理多个计划合并创意组的情况
          for (const i in groups) {
            const group = groups[i]
            // 第一个作为主任务
            const mainTask = group[0]
            // 找到当前组下面所有的创意组，合并到主任务中
            mainTask.creativeFormGroups = group.map((g) => g.creativeFormGroups[0])
            taskObj[mainTask.taskId] = mainTask
          }
          this.taskList = Object.values(taskObj)
        } else {
          this.taskList = taskList
        }

        // 获取素材标签数据
        this.queryMaterialTags()

        this.initQueryGroupImageThumbnailLoop()

        this.pageLoading = false
      } catch (e) {
        console.log(' getTaskData error output: ', e)
        this.pageLoading = false
      }
    },

    /**
     * @description: 根据账号获取投放素材标签
     */
    queryMaterialTags() {
      this.materialTagsLoading = true
      getAllMediaTagList({ mediaId: MEDIAS.GDT, accountId: this.currTask.ad_account_id }).then((data) => {
        this.materialTagsLoading = false
        this.materialTagList = data
      })
    },

    onMaterialLabelChange() {
      // 素材标签切换时清除素材选择
      this.creativeFormGroups = this.creativeFormGroups.map((c) => {
        return { ...c, selectedAssets: {} }
      })
    },
    /**
     * @description: 清除校验，被子组件调用
     */
    async doPlanFormClearValidate() {
      for (const i in this.$refs) {
        if (i.startsWith('ada-form')) {
          this.$refs[i]?.clearValidate()
        }
      }
    },
    /**
     * @description: 获取页面账号等下拉数据
     * @return {*}
     */
    getPageData() {
      adAccount({ mediaId: 16, authFlag: 1 }).then((data) => {
        this.accountList = data.map((d) => ({ ...d, value: d.name }))

        // 获取任务数据
        this.getTaskData()
      })
    }
  },
  created() {
    this.getPageData()
    this.currTaskId = taskIds[0] || 0
  }
}
</script>
<style lang="scss" scoped>
.gdt-modify-wrapper {
  height: calc(100vh - 64px);
  overflow: auto;
}
.disable-plan-form {
  position: relative;
  z-index: 1;

  &:before {
    width: 100%;
    height: calc(100% + 40px);
    content: ' ';
    position: absolute;
    margin-top: -20px;
    margin-bottom: -20px;
    background-color: rgba(88, 88, 88, 0.04);
    cursor: not-allowed;
    z-index: 2;
  }
}
.plan-modify {
  margin: 10px 15px;
}

.submit-row {
  width: 100%;
  position: sticky;
  bottom: 0;
  z-index: 10;
  border: 1px solid #eaeaea;
  text-align: right;
  padding: 12px;
  background-color: #fff;
}

.material-tags {
  display: flex;
}
</style>
